import $ from 'jquery';
import App from '../App';

$(function() {
  App.init();
});
